import React from 'react';
import trashIcon from '../assets/icons/trash.svg';

function BasketModalItem({
  title, price, isBook, handleDeleteFromBasket, id,
}) {
  return (
    <div className={`basket-item ${isBook && 'book-item'}`}>
      <div className="basket-item-info">
        <p className="basket-item-info-title">{title}</p>
        <p className="basket-item-info-price">{price}</p>
      </div>
      <button onClick={() => handleDeleteFromBasket(id)} type="button" className="basket-item-delete">
        <img src={trashIcon} alt="trash" />
      </button>
    </div>
  );
}

export default BasketModalItem;
